/* Fiche produit Minicar — comportement.
   Toute la configuration arrive par le bloc JSON [data-mcp-data] pose par la
   section, ce qui permet de garder ce fichier statique et cache. */
(function () {
  function boot(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var holder = root.querySelector('[data-mcp-data]');
    if (!holder) return;
    var DATA = JSON.parse(holder.textContent);
    var C = DATA.cfg;
    var variants = DATA.variants;
    var qtyMap = DATA.qty;

    var LBL_ADD = C.add, LBL_SOLD = C.sold;
    var TXT_IN = C.stock_in, TXT_LOW = C.stock_low, TXT_OUT = C.stock_out;
    var LOW = C.low, UP_PRICE = C.up_price, UP_SHORT = C.up_short;
    var TAG = C.tag, MFMT = C.mfmt, CHOICES = C.choices, CART = C.cart;

    /* Format des prix : on suit exactement celui de la boutique. */
    function money(cents) {
      var neg = cents < 0;
      cents = Math.abs(Math.round(cents));
      var m = MFMT.match(/\{\{\s*([a-z_]+)\s*\}\}/);
      var key = m ? m[1] : 'amount';
      var dec = '.', tho = ',';
      if (key.indexOf('comma_separator') > -1) { dec = ','; tho = '.'; }
      else if (key.indexOf('space_separator') > -1) { dec = ','; tho = ' '; }
      var noDec = key.indexOf('no_decimals') > -1;
      var parts = (cents / 100).toFixed(noDec ? 0 : 2).split('.');
      var s = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, tho);
      if (!noDec) s += dec + parts[1];
      return (neg ? '-' : '') + (m ? MFMT.replace(m[0], s) : s);
    }
    function big() { return window.matchMedia('(min-width: 990px)').matches; }

    /* ---------- Galerie ---------- */
    var slides = root.querySelector('[data-mcp-slides]');
    var box = root.querySelector('[data-mcp-thumbs]');
    var thumbs = root.querySelectorAll('[data-mcp-thumbs] .mcp__thumb');
    var aUp = root.querySelector('[data-mcp-tup]');
    var aDn = root.querySelector('[data-mcp-tdown]');
    var countEl = root.querySelector('[data-mcp-count]');
    var prev = root.querySelector('[data-mcp-prev]');
    var next = root.querySelector('[data-mcp-next]');

    function slideCount() { return slides ? slides.children.length : 0; }
    function currentIndex() { return slides && slides.clientWidth ? Math.round(slides.scrollLeft / slides.clientWidth) : 0; }
    function goTo(i) {
      if (!slides) return;
      i = Math.max(0, Math.min(slideCount() - 1, i));
      slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
    }

    /* Vignettes : fleches haut / bas, aucune barre de defilement visible.
       Le defilement doux natif n'est pas fiable sur un conteneur imbrique,
       on anime donc nous-memes. */
    if (box) box.style.scrollBehavior = 'auto';
    var tRaf = 0;
    function arrows() {
      if (!box || !aUp || !aDn) return;
      var max = box.scrollHeight - box.clientHeight;
      if (!big() || max < 4) { aUp.hidden = true; aDn.hidden = true; return; }
      aUp.hidden = false; aDn.hidden = false;
      aUp.style.visibility = box.scrollTop > 4 ? 'visible' : 'hidden';
      aDn.style.visibility = box.scrollTop < max - 4 ? 'visible' : 'hidden';
    }
    function tscroll(to) {
      if (!box) return;
      var max = box.scrollHeight - box.clientHeight;
      to = Math.max(0, Math.min(max, to));
      var from = box.scrollTop, d = to - from, t0 = 0;
      if (Math.abs(d) < 1) { arrows(); return; }
      if (tRaf) window.cancelAnimationFrame(tRaf);
      var step = function (ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / 300);
        var e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        box.scrollTop = from + d * e;
        arrows();
        if (k < 1) tRaf = window.requestAnimationFrame(step); else tRaf = 0;
      };
      tRaf = window.requestAnimationFrame(step);
    }
    function tstep(dir) {
      if (!box) return;
      var one = box.querySelector('.mcp__thumb');
      var h = one ? one.offsetHeight + 9 : 93;
      tscroll(box.scrollTop + dir * h * 2);
    }
    if (aUp) aUp.addEventListener('click', function () { tstep(-1); });
    if (aDn) aDn.addEventListener('click', function () { tstep(1); });
    if (box) box.addEventListener('scroll', function () { window.requestAnimationFrame(arrows); }, { passive: true });
    window.addEventListener('resize', arrows);
    window.addEventListener('load', arrows);

    function sync() {
      var i = currentIndex();
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-on', on);
        if (on && box && big()) {
          var r = t.getBoundingClientRect(), rb = box.getBoundingClientRect();
          if (r.top < rb.top - 1) tscroll(box.scrollTop + (r.top - rb.top));
          else if (r.bottom > rb.bottom + 1) tscroll(box.scrollTop + (r.bottom - rb.bottom));
        }
      });
      if (countEl) countEl.textContent = (i + 1) + ' / ' + slideCount();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slideCount() - 1;
      arrows();
    }
    if (slides) {
      slides.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.i, 10)); }); });
      if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
      sync();
    }
    setTimeout(arrows, 800);

    /* ---------- Onglets ----------
       La barre est collante (CSS) : son conteneur .mcp__content la borne
       naturellement, elle ne suit donc que la longueur du panneau ouvert. */
    var tabs = root.querySelectorAll('[data-mcp-tabs] .mcp-tab');
    var panes = root.querySelectorAll('.mcp-pane[data-pane]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var k = t.dataset.tab;
        tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panes.forEach(function (pn) { pn.classList.remove('is-on'); if (pn.dataset.pane === k) pn.classList.add('is-on'); });
        snapToTabs();
      });
    });

    /* Au changement d'onglet on ramene le lecteur en haut du panneau,
       sinon il reste a la hauteur ou il lisait le panneau precedent. */
    var tabBar = root.querySelector('[data-mcp-tabs]');
    var tabBox = root.querySelector('.mcp__content');
    function snapToTabs() {
      if (!tabBar || !tabBox) return;
      /* La barre etant collante, son propre rectangle donne la position
         *collee* : on part donc du conteneur, qui lui ne bouge pas. */
      var stick = parseFloat(getComputedStyle(tabBar).top) || 0;
      var pad = parseFloat(getComputedStyle(tabBox).paddingTop) || 0;
      var y = window.pageYOffset + tabBox.getBoundingClientRect().top + pad - stick - 10;
      if (Math.abs(window.pageYOffset - y) > 4) window.scrollTo({ top: y, behavior: 'smooth' });
    }

    /* ---------- Questions frequentes ---------- */
    var qa = root.querySelector('[data-mcp-qa]');
    if (qa) {
      qa.querySelectorAll('.mcp-qa__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.parentElement;
          var open = item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }

    /* ---------- Variantes ---------- */
    var idInput = root.querySelector('[data-mcp-id]');
    var mainAtc = root.querySelector('[data-mcp-form] [data-mcp-atc]');
    var atcs = root.querySelectorAll('[data-mcp-atc]');
    var priceBox = root.querySelector('[data-mcp-price]');
    var barPrice = root.querySelector('[data-mcp-barprice]');
    var barSub = root.querySelector('[data-mcp-barsub]');
    var sheetPrice = root.querySelector('[data-mcp-sheetprice]');
    var sheetTot = root.querySelector('[data-mcp-sheettot]');
    var stock = root.querySelector('[data-mcp-stock]');
    var stockT = root.querySelector('[data-mcp-stock-t]');
    var stockF = root.querySelector('[data-mcp-stock-f]');

    function chosen() {
      var out = [];
      root.querySelectorAll('[data-mcp-scope="main"] [data-mcp-opt]').forEach(function (g) {
        var r = g.querySelector('input[data-mcp-radio]:checked');
        out[parseInt(g.dataset.mcpOpt, 10)] = r ? r.value : null;
      });
      return out;
    }
    function findVariant() {
      var sel = chosen();
      if (!sel.length) return variants[0];
      return variants.find(function (v) {
        return sel.every(function (val, i) { return val == null || v.options[i] === val; });
      });
    }
    function setScope(scope, oidx, value) {
      root.querySelectorAll('[data-mcp-scope="' + scope + '"] input[data-mcp-radio]').forEach(function (x) {
        if (x.dataset.opt === oidx) x.checked = (x.value === value);
      });
    }

    function update() {
      root.querySelectorAll('[data-mcp-opt]').forEach(function (g) {
        var r = g.querySelector('input[data-mcp-radio]:checked');
        var lab = g.querySelector('[data-mcp-optv]');
        if (r && lab) lab.textContent = r.dataset.short || r.value;
      });

      var v = findVariant();
      var upSel = root.querySelector('[data-mcp-upsell]:checked');
      var upOn = !!(upSel && upSel.value);
      if (!v) {
        atcs.forEach(function (b) { b.disabled = true; var l = b.querySelector('[data-mcp-atc-label]'); if (l) l.textContent = LBL_SOLD; });
        return;
      }
      if (idInput) idInput.value = v.id;

      var off = 0;
      if (v.compare_at_price && v.compare_at_price > v.price) off = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price);
      if (priceBox) {
        var html = '<span class="mcp__p-now">' + money(v.price) + '</span>';
        if (off > 0) html += '<span class="mcp__p-was">' + money(v.compare_at_price) + '</span><span class="mcp__p-off">' + TAG + 'Promo -' + off + ' %</span>';
        priceBox.innerHTML = html;
      }
      if (barPrice) barPrice.textContent = money(v.price);
      if (sheetPrice) sheetPrice.textContent = money(v.price);
      if (sheetTot) sheetTot.textContent = money(v.price + (upOn ? UP_PRICE : 0));
      if (barSub) {
        var bits = [];
        root.querySelectorAll('[data-mcp-scope="main"] [data-mcp-opt] input[data-mcp-radio]:checked').forEach(function (r) { bits.push(r.dataset.short || r.value); });
        if (upOn) bits.push(UP_SHORT);
        barSub.textContent = bits.join(' · ');
      }
      atcs.forEach(function (b) {
        b.disabled = !v.available;
        var l = b.querySelector('[data-mcp-atc-label]');
        if (l) l.textContent = v.available ? LBL_ADD : LBL_SOLD;
      });

      if (stock && stockT) {
        var q = qtyMap[v.id];
        if (q === undefined) q = 99999;
        var pct = 100;
        stock.classList.remove('mcp__stock--low', 'mcp__stock--out');
        if (!v.available) { stock.classList.add('mcp__stock--out'); stockT.textContent = TXT_OUT; pct = 0; }
        else if (q > 0 && q <= LOW) { stock.classList.add('mcp__stock--low'); stockT.textContent = TXT_LOW.replace('[n]', q); pct = Math.max(10, Math.round(q * 100 / LOW)); }
        else { stockT.textContent = TXT_IN; }
        if (stockF) stockF.style.width = pct + '%';
      }

      if (v.featured_media && slides) {
        var target = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (target) goTo(Array.prototype.indexOf.call(slides.children, target));
      }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }

    root.querySelectorAll('input[data-mcp-radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        var other = r.dataset.scope === 'main' ? 'sheet' : 'main';
        setScope(other, r.dataset.opt, r.value);
        update();
      });
    });
    /* La garantie est maintenant un choix entre deux cartes (radios).
       Les deux copies du bloc d'achat (achat principal et tiroir de la
       barre collante) ont des groupes distincts : on les recale l'une sur
       l'autre a chaque changement. */
    var ups = root.querySelectorAll('[data-mcp-upsell]');
    ups.forEach(function (u) {
      u.addEventListener('change', function () {
        if (!u.checked) return;
        ups.forEach(function (x) { if (x !== u) x.checked = (x.value === u.value); });
        root.querySelectorAll('[data-mcp-warv]').forEach(function (v) { v.textContent = u.dataset.short || ''; });
        update();
      });
    });

    /* ---------- Tiroir de la barre collante ---------- */
    var sheet = root.querySelector('[data-mcp-sheet]');
    function openSheet() {
      if (!sheet) return;
      sheet.classList.add('is-on');
      sheet.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeSheet() {
      if (!sheet) return;
      sheet.classList.remove('is-on');
      sheet.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }
    root.querySelectorAll('[data-mcp-sheetclose]').forEach(function (x) { x.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

    /* ---------- Ajout au panier ----------
       L'extension de garantie n'est jointe que si elle n'est pas deja au
       panier : /cart/add.js est atomique, un article deja au maximum ferait
       echouer tout l'ajout. En cas de refus on affiche le message de Shopify
       au lieu d'envoyer le client sur la page panier. */
    var errBox = root.querySelector('[data-mcp-err]');
    function note(msg) {
      if (!errBox) return;
      errBox.textContent = msg || '';
      errBox.hidden = !msg;
    }

    var busy = false;
    function addToCart(btn) {
      if (busy) return;
      var v = findVariant();
      if (!v || !v.available) return;
      busy = true;
      note('');
      var lab = btn ? btn.querySelector('[data-mcp-atc-label]') : null;
      var old = lab ? lab.textContent : '';
      if (lab) lab.textContent = 'Ajout…';

      var scopeEl = (sheet && sheet.classList.contains('is-on')) ? sheet : root;
      var upEl = scopeEl.querySelector('[data-mcp-upsell]:checked') || root.querySelector('[data-mcp-upsell]:checked');
      var upId = upEl && upEl.value ? parseInt(upEl.value, 10) : 0;

      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = [{ id: v.id, quantity: 1 }];
          var already = false;
          (cart.items || []).forEach(function (it) { if (it.variant_id === upId || it.id === upId) already = true; });
          if (upId && !already) items.push({ id: upId, quantity: 1 });
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (res) {
          return res.json().then(function (j) { return { ok: res.ok, j: j }; }, function () { return { ok: res.ok, j: null }; });
        })
        .then(function (out) {
          if (!out.ok) {
            note((out.j && (out.j.description || out.j.message)) || 'Ajout impossible pour le moment.');
            return;
          }
          closeSheet();
          document.dispatchEvent(new CustomEvent('mc:cart:added'));
          if (typeof window.mcdOpenCart !== 'function') window.location.href = CART;
        })
        .catch(function () { note('Ajout impossible pour le moment.'); })
        .finally(function () {
          busy = false;
          if (lab) lab.textContent = old;
        });
    }
    var form = root.querySelector('[data-mcp-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(mainAtc); });
    var sheetAtc = root.querySelector('[data-mcp-sheetatc]');
    if (sheetAtc) sheetAtc.addEventListener('click', function () { addToCart(sheetAtc); });
    var barBtn = root.querySelector('[data-mcp-barbtn]');
    if (barBtn) barBtn.addEventListener('click', function () { if (CHOICES && sheet) openSheet(); else addToCart(mainAtc); });

    /* ---------- Barre collante ----------
       Elle n'apparait qu'une fois le bouton d'ajout ENTIEREMENT depasse vers le
       haut. Pilotage au defilement plutot qu'avec un IntersectionObserver :
       l'etat est recalcule a chaque scroll, jamais fige. */
    var bar = root.querySelector('[data-mcp-bar]');
    function barSync() {
      if (!bar || !mainAtc) return;
      bar.classList.toggle('is-on', mainAtc.getBoundingClientRect().bottom < 0);
    }
    if (bar && mainAtc) {
      window.addEventListener('scroll', barSync, { passive: true });
      window.addEventListener('resize', barSync);
      barSync();
    }

    /* ---------- Ecrire un avis (Loox) ---------- */
    var writeBtn = root.querySelector('[data-mcp-write]');
    if (writeBtn) {
      writeBtn.addEventListener('click', function () {
        if (typeof window.looxWrite === 'function') { window.looxWrite(); return; }
        if (window.LOOX && typeof window.LOOX.showReviewForm === 'function') { window.LOOX.showReviewForm(); return; }
        window.location.hash = 'loox-review';
      });
    }

    /* ---------- Avis Loox ---------- */
    var lx = root.querySelector('#looxReviews');
    var lxEmpty = root.querySelector('[data-mcp-rev-empty]');
    if (lx && lxEmpty) {
      var check = function () { if (lx.children.length > 0) lxEmpty.style.display = 'none'; };
      check();
      new MutationObserver(check).observe(lx, { childList: true });
      setTimeout(check, 3000);
    }

    update();
  }

  function init() { document.querySelectorAll('[data-mcp]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
